import { FeatureData } from '../../components/ui/feature-section-with-hoover-effect';
import {
  IconShieldUp,
  IconBuildingSkyscraper,
  IconBuildingEstate,
  IconChartBar,
} from '@tabler/icons-react';

const cyberDataFeatures: FeatureData[] = [
  {
    title: 'Les entreprises soucieuses de leur sécurité numérique',
    description:
      'Protégez votre entreprise, votre réputation et vos clients en surveillant activement vos données sensibles, pour anticiper et réagir rapidement face aux risques de fuites.',
    icon: <IconShieldUp size={24} />,
    key: 'features.cyberData.feature1'
  },
  {
    title: 'Collectivités et organismes publics',
    description:
      'Anticipez les risques de fuites de données avec une surveillance proactive afin de renforcer votre transparence et préserver votre crédibilité auprès des citoyens.',
    icon: <IconBuildingEstate size={24} />,
    key: 'features.cyberData.feature2'
  },
  {
    title: 'Grandes entreprises',
    description:
      'Préservez votre avantage concurrentiel en protégeant vos informations stratégiques avec une surveillance active contre les fuites d\'informations critiques.',
    icon: <IconBuildingSkyscraper size={24} />,
    key: 'features.cyberData.feature3'
  },
  {
    title: 'Organisations gérant des données sensibles',
    description:
      'Anticipez les risques de fuites de données sensibles avec une surveillance proactive et réduisez les conséquences financières et juridiques associées.',
    icon: <IconChartBar size={24} />,
    key: 'features.cyberData.feature4'
  },
];

export default cyberDataFeatures; 